module.exports = __webpack_public_path__ + "img/element_3.9288448c.png";